export default [
  {
    path: '/admin/product-costs',
    name: 'product-cost',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/cost')
  }
]
